import { useCallback, useEffect, useMemo, useState } from 'react';

import HubspotContext from './HubspotContext';

const hubspot_link = 'https://js-na1.hs-scripts.com/2239864.js';
const script_id = 'hs-script-loader';

const Hubspot = (props) => {
  const { children } = props;

  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!initialized && !loading && !error) {
      const body = document.body;
      const script = document.createElement('script');
      script.setAttribute('async', true);
      script.setAttribute('defer', true);
      script.id = script_id;

      script.onerror = () => {
        setError(true);
        setLoading(false);
      };
      script.onload = () => {
        setLoading(false);
        setInitialized(true);
      };
      body.appendChild(script);
      script.src = hubspot_link;
      setLoading(true);
    }
  }, [initialized, loading, error]);

  const open = useCallback(() => {
    if (initialized) {
      window.HubSpotConversations?.widget?.open();
    }
  }, [initialized]);

  const hubspotApi = useMemo(() => {
    return {
      initialized,
      loading,
      error,
      open,
    };
  }, [initialized, loading, error, open]);

  return (
    <HubspotContext.Provider value={hubspotApi}>
      {children}
    </HubspotContext.Provider>
  );
};

export default Hubspot;
